export enum MessageSources {
    TWILIO_SMS = 'TWILIO_SMS',
    KUMODI_SMS = 'KUMODI_SMS',
    TELEGRAM = 'TELEGRAM',
    WEBSOCKET = 'WEBSOCKET',
    WHATSAPP = 'WHATSAPP',
    EMAIL = 'EMAIL',
}

export enum SocialMediaPlatform {
    TWITTER = 'TWITTER',
    FACEBOOK = 'FACEBOOK',
    INSTAGRAM = 'INSTAGRAM',
    SMS = 'SMS',
    WHATSAPP = 'WHATSAPP'
}